import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

export const Container = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 960px;
  margin: 0 auto;
  padding: 1rem 2.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  ${down('md')} {
    padding: 1rem;
  }
`;

export const SpinnerWrapper = styled.div`
  display: grid;
  place-content: center;

  > div {
    overflow: hidden;
  }
`;

export const EmptyState = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    text-align: center;

    > svg {
      margin-bottom: 1.25rem;
      opacity: 0.7;
    }

    > h3 {
      font-size: 1rem;
      font-weight: 600;
      color: ${theme.colors.foreground[80]};
      margin-bottom: 0.375rem;
    }

    > p {
      font-size: 0.8125rem;
      color: ${theme.colors.foreground[40]};
    }
  `}
`;

export const LoadMoreButton = styled.button`
  ${({ theme }) => css`
    border-radius: 1000rem;
    color: ${theme.colors.brand.primary.default};
    background: ${theme.colors.brand.primary.opaque};
    transition: 180ms ease-in-out;

    :hover {
      color: ${theme.colors.brand.primary.text};
      background: ${theme.colors.brand.primary.default};
    }
  `};
`;
